<template>
    <system-tabs :tabs="tabs">
        <template slot="help">
            <helpMail/>
        </template>

        <template slot="w1">
            <interface-mail disabled-send disabled-delete :folders="folders" :mails="mails" @sort="onSort"/>
        </template>
    </system-tabs>
</template>

<script>
    import {mapGetters} from 'vuex'
    import InterfaceMail from '@/components/interface/mail'
    import SystemTabs from '@/components/system/tabs'
    import data from './data.json'
    import helpMail from '@/components/interface/mail/help'

    export default {
        components: {
            InterfaceMail,
            SystemTabs,
            helpMail
        },
        data () {
            return {
                actions: {
                    success: false
                },
                folders: data.folders,
                mails: data.mails,
                tabs: [
                    {
                        title: 'Электронная почта',
                        name: 'email',
                        slot: 'w1'
                    }
                ]
            }
        },
        computed: {
            ...mapGetters('questions', ['question'])
        },
        methods: {
            onSort () {
                if (this.question.id === 5) {
                    this.actions.success = this.checkStep1()
                } else if (this.question.id === 6) {
                    this.actions.success = this.checkStep2()
                }

                this.$store.dispatch('questions/answer', {
                    success: this.actions.success
                })
            },
            checkStep1 () {
                let count = 0
                this.mails.forEach(item => {
                    if (item.id === 1 && item.folder === 5 ||
                        item.id === 10 && item.folder === 5 ||
                        item.id === 8 && item.folder === 5 ||
                        item.id === 13 && item.folder === 5 ||
                        item.id === 4 && item.folder === 4 ||
                        item.id === 11 && item.folder === 4
                    ) {
                        count++
                    }
                })
                let folder1 = this.mails.filter(item => item.folder === 4).length
                let folder2 = this.mails.filter(item => item.folder === 5).length

                return count === 6 && folder1 === 2 && folder2 === 4
            },

            checkStep2 () {
                let folder2mails = this.mails.filter(item => item.folder === 5).length
                let folder2 = this.folders[2].folders[1]
                let idInnerFolder = folder2.folders.length && folder2.folders[0].id
                let folderInnerMails = 0
                let count = 0

                if (idInnerFolder) {
                    folderInnerMails = this.mails.filter(item => item.folder === idInnerFolder).length
                    this.mails.forEach(item => {
                        if (item.id === 1 && item.folder === idInnerFolder ||
                            item.id === 8 && item.folder === idInnerFolder ||
                            item.id === 13 && item.folder === idInnerFolder
                        ) {
                            count++
                        }
                    })
                }

                return folder2mails === 1 && folderInnerMails === 3 && count === 3
            },

            // Завершение теста
            // Выполнение необходимых действий перед
            // переходом к следующему заданию / этипу
            finish () {}
        }
    }
</script>
